import { configQuery } from '@gig/magic-common';
import { USER_JURISDICTION_UPDATED, GAME_SESSION_UPDATED, BREAKPOINT_DEVICE_UPDATED, DEVICE_QUERY_IS_DESKTOP, ENABLE_CONTINUE_PLAYING_QUERY, NET_POSITION_BAR_UPDATED, NET_POSITION_AMOUNT_UPDATED, ENABLE_CONTINUE_PLAYING_UPDATED, FEATURE_QUERY_VALUE, Feature } from '@gig/magic-messages';
import { magic } from '@gig/magic-sdk';
import { isUKGC, isAGCO } from '@gig/magic-jurisdictions/dist/jurisdictions.constants';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class GameSessionService {
  constructor() {
    this.isDesktop = false;
    this.gameSession = null;
    this.netPosition = 0;
    this.gameTransactionSubscription = null;
    this.registerSchemas();
    this.subscribeToNetPositionBarChanges();
    this.subscribeToEnableContinuePlayingChanges();
  }
  subscribeToNetPositionBarChanges() {
    window.eventBus.subscribe([USER_JURISDICTION_UPDATED, GAME_SESSION_UPDATED], (event) => __async(this, null, function* () {
      var _a, _b;
      this.jurisdiction = (_a = event.payload) == null ? void 0 : _a[0];
      this.gameSession = (_b = event.payload) == null ? void 0 : _b[1];
      yield this.updateNetPositionBar();
    }), { replay: true });
  }
  subscribeToEnableContinuePlayingChanges() {
    window.eventBus.subscribe([USER_JURISDICTION_UPDATED, BREAKPOINT_DEVICE_UPDATED], (event) => __async(this, null, function* () {
      var _a;
      this.jurisdiction = (_a = event.payload) == null ? void 0 : _a[0];
      this.isDesktop = yield window.queryBus.query(DEVICE_QUERY_IS_DESKTOP);
      yield this.updateEnableContinuePlaying();
    }), { replay: true });
    window.queryBus.subscribe(ENABLE_CONTINUE_PLAYING_QUERY, () => __async(this, null, function* () {
      return yield this.shouldEnableContinuePlaying();
    }));
  }
  updateNetPositionBar() {
    return __async(this, null, function* () {
      const visible = yield this.shouldShowNetPositionBar();
      if (visible) {
        this.initNetPositionTracking();
      } else {
        this.resetNetPositionTracking();
      }
      window.eventBus.publish(NET_POSITION_BAR_UPDATED, visible);
    });
  }
  initNetPositionTracking() {
    if (this.gameTransactionSubscription) {
      return;
    }
    this.netPosition = 0;
    window.eventBus.publish(NET_POSITION_AMOUNT_UPDATED, 0);
    this.gameTransactionSubscription = magic.events.gameTransaction((event) => {
      if (!(event.amount > 0)) {
        return;
      }
      this.netPosition += event.balanceAfter - event.balanceBefore;
      window.eventBus.publish(NET_POSITION_AMOUNT_UPDATED, this.netPosition);
    });
  }
  resetNetPositionTracking() {
    var _a;
    this.netPosition = 0;
    window.eventBus.publish(NET_POSITION_AMOUNT_UPDATED, 0);
    (_a = this.gameTransactionSubscription) == null ? void 0 : _a.unsub();
    this.gameTransactionSubscription = null;
  }
  updateEnableContinuePlaying() {
    return __async(this, null, function* () {
      const enable = yield this.shouldEnableContinuePlaying();
      window.eventBus.publish(ENABLE_CONTINUE_PLAYING_UPDATED, enable);
    });
  }
  shouldEnableContinuePlaying() {
    return __async(this, null, function* () {
      return this.isDesktop && !this.isNetPositionBarAvailableForJurisdiction() && (yield this.isEnableContinuePlayingAllowed());
    });
  }
  shouldShowNetPositionBar() {
    return __async(this, null, function* () {
      var _a;
      const loggedIn = !!magic.session.getUser();
      return loggedIn && !!((_a = this.gameSession) == null ? void 0 : _a.active) && this.isNetPositionBarAvailableForJurisdiction() && !(yield this.disableNetPositionBarFlag());
    });
  }
  disableNetPositionBarFlag() {
    return __async(this, null, function* () {
      var _a;
      const disableGameplayInfoFlag = yield window.queryBus.query(FEATURE_QUERY_VALUE, {
        slug: Feature.GAMEPLAY_INFORMATION_DISABLED
      });
      const disabledForVendors = disableGameplayInfoFlag == null ? void 0 : disableGameplayInfoFlag.value.toLowerCase();
      const vendor = (_a = this.gameSession) == null ? void 0 : _a.vendor.toLowerCase();
      return (disableGameplayInfoFlag == null ? void 0 : disableGameplayInfoFlag.isApplicable) && vendor && disabledForVendors.includes(vendor);
    });
  }
  isNetPositionBarAvailableForJurisdiction() {
    return isUKGC(this.jurisdiction) || isAGCO(this.jurisdiction);
  }
  isEnableContinuePlayingAllowed() {
    return __async(this, null, function* () {
      return !!(yield configQuery("enableContinuePlaying"));
    });
  }
  registerSchemas() {
    window.eventBus.register(NET_POSITION_BAR_UPDATED, {
      type: "boolean"
    });
    window.eventBus.register(ENABLE_CONTINUE_PLAYING_UPDATED, {
      type: "boolean"
    });
    window.queryBus.register(ENABLE_CONTINUE_PLAYING_QUERY, {
      type: "boolean"
    });
    window.eventBus.register(GAME_SESSION_UPDATED, {
      type: "object",
      properties: {
        active: {
          type: "boolean"
        },
        sessionStartMs: {
          type: "number"
        },
        vendor: {
          type: "string"
        }
      }
    });
  }
}

export { GameSessionService };
